import { filterService } from '@/entities/filter/api/filter.api';
import { useQuery } from '@tanstack/react-query';

/** 선택지는 화면 사이에서 자주 바뀌지 않아 5분 캐시한다 */
const FILTER_STALE_TIME = 5 * 60 * 1000;

export const filterKeys = {
  all: ['partner-filters'] as const,
  users: () => [...filterKeys.all, 'users'] as const,
  regions: () => [...filterKeys.all, 'regions'] as const,
  pharmaCompanies: () => [...filterKeys.all, 'pharma-companies'] as const,
};

export const useUserOptions = () =>
  useQuery({
    queryKey: filterKeys.users(),
    queryFn: filterService.users,
    staleTime: FILTER_STALE_TIME,
  });

export const useRegionOptions = () =>
  useQuery({
    queryKey: filterKeys.regions(),
    queryFn: filterService.regions,
    staleTime: FILTER_STALE_TIME,
  });

export const usePharmaCompanyOptions = () =>
  useQuery({
    queryKey: filterKeys.pharmaCompanies(),
    queryFn: filterService.pharmaCompanies,
    staleTime: FILTER_STALE_TIME,
  });
